import React, { useState, useEffect } from "react"
import { Form, FastField, withFormik, Field } from "formik"
import { parsePhoneNumber } from "libphonenumber-js"
import * as Yup from "yup"
import {
  TextField,
  MobileNumberField,
  StateField,
  CityField,
  BarangayField,
  CheckBox,
  PasswordField,
  CountryField
} from "../../common/Fields"
import Card from "../../common/Card"
import "./CreateAccountForm.css"
import PasswordStrength from "../PasswordStrength"
import Terms from "../../landing/Terms"
import Privacy from "../../landing/PrivacyPolicy"
import DialogBox from "../../common/DialogBox"
import { API, API_PUBLIC } from "../../api"

function BaseAccountForm({
  touched,
  isSubmitting,
  errors,
  values,
  backHandler,
  setFieldValue,
  customerData,
  orderUuid,
  isNewOrder
}) {
  const [showModal, setShowModal] = useState(false)
  function toggleShowModal(e) {
    e.preventDefault()
    setShowModal(!showModal)
  }
  const [showPrivacyModal, setShowPrivacyModal] = useState(false)
  function toggleShowPrivacyModal(e) {
    e.preventDefault()
    setShowPrivacyModal(!showPrivacyModal)
  }
  useEffect(
    () => {
      if (
        values.country.value &&
        values.country.value.toLowerCase() !== "philippines" &&
        values.city.hasOwnProperty("value")
      ) {
        setFieldValue("city", "")
        setFieldValue("barangay", "")
      }
    },
    [values.country.value, values.city, setFieldValue]
  )
  return (
    <div className="CreateAccount">
      <Form className="CreateAccountForm">
        <Card>
          <h1 className="header">CREATE AN ACCOUNT </h1>
          <div className="helper">
            <p>
              Enjoy a smoother and faster transaction when you create an
              account! You've already filled up 90% of required information
            </p>
          </div>
          <fieldset>
            <hr />
            <span className="password">
              <label>Password</label>
              <FastField
                component={PasswordField}
                name="password"
                type="password"
              />
              <div className="password-strength-indicator">
                <PasswordStrength password={values.password} />
              </div>
            </span>
            <hr />
            <div className="two-column">
              <span>
                <label>First Name</label>
                <FastField component={TextField} name="firstName" type="text" />
              </span>
              <span>
                <label>Last Name</label>
                <FastField component={TextField} name="lastName" type="text" />
              </span>
            </div>
            <span>
              <label>Email Address</label>
              <FastField component={TextField} name="email" type="text" />
            </span>
            <span>
              <label>Mobile Number</label>
              <MobileNumberField
                groupName="mobile"
                countryCodeName="countryCode"
                mobileNumberName="mobileNumber"
                errors={errors}
                touched={touched}
                values={values}
                disabled={
                  (customerData &&
                  customerData.mobile &&
                  customerData.mobile.countryCode &&
                  customerData.mobile.mobileNumber
                    ? true
                    : false) || !isNewOrder
                }
              />
            </span>
            <span className="line-one">
              <label>Address Line 1</label>
              <FastField
                name="addressLineOne"
                component={TextField}
                placeholder="Street and number, P.O. box, c/o"
                type="text"
              />
            </span>
            <span className="line-two">
              <label>Address Line 2 (Optional)</label>
              <FastField
                name="addressLineTwo"
                component={TextField}
                placeholder="Apartment, suite, unit building, floor, etc."
                type="text"
              />
            </span>
            <div className="two-column">
              <span>
                <label>Country</label>
                <FastField
                  component={CountryField}
                  name="country"
                  type="text"
                  value={values.country}
                />
              </span>
              <span>
                <label>Province/State</label>
                <Field
                  name="province"
                  component={StateField}
                  value={values.province}
                  type="text"
                  countryname={values.country.value}
                />
              </span>
            </div>
            <div className="two-column">
              <span>
                <label>City</label>
                {(values.country.value &&
                  values.country.value.toLowerCase() === "philippines" && (
                    <Field
                      name="city"
                      component={CityField}
                      value={values.city}
                      type="text"
                      statename={values.province.value}
                    />
                  )) || (
                  <FastField
                    component={TextField}
                    name="city"
                    type="text"
                    value={
                      values.city.hasOwnProperty("value")
                        ? values.city.value
                        : values.city
                    }
                  />
                )}
              </span>
              <span>
                <label>Zip Code</label>
                <FastField name="zipcode" component={TextField} type="text" />
              </span>
            </div>
            {values.country.value &&
              values.country.value.toLowerCase() === "philippines" && (
                <div className="two-column">
                  <span>
                    <label>Barangay</label>
                    <Field
                      name="barangay"
                      component={BarangayField}
                      value={values.barangay}
                      type="text"
                      cityname={values.city.value}
                    />
                  </span>
                </div>
              )}
            <span className="checkbox-container">
              <FastField
                component={CheckBox}
                name="terms"
                checked={values.terms}
                placeholder={[
                  "I accept the",
                  <a
                    key="link"
                    href={"/"}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={toggleShowModal}
                  >
                    Terms and Conditions
                  </a>,
                  " and",
                  <a
                    key="privacy-link"
                    href={"/"}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={toggleShowPrivacyModal}
                  >
                    Privacy Policy
                  </a>
                ]}
              />
            </span>
            <div className="two-column form-buttons">
              <button type="button" className="gray" onClick={backHandler}>
                Cancel
              </button>
              <button type="submit" className="black">
                {isSubmitting ? "Submitting" : "Submit"}
              </button>
            </div>
          </fieldset>
        </Card>
      </Form>
      {showModal && (
        <DialogBox
          primaryAction={() => {}}
          primaryActionLabel={""}
          secondaryAction={() => {}}
          secondaryActionLabel=""
          close={toggleShowModal}
          closeLabel=""
          title=""
        >
          <Terms />
        </DialogBox>
      )}
      {showPrivacyModal && (
        <DialogBox
          primaryAction={() => {}}
          primaryActionLabel={""}
          secondaryAction={() => {}}
          secondaryActionLabel=""
          close={toggleShowPrivacyModal}
          closeLabel=""
          title=""
        >
          <Privacy />
        </DialogBox>
      )}
    </div>
  )
}

const CreateAccountForm = withFormik({
  mapPropsToValues: ({ customerData }) => ({
    password: "",
    addressLineOne: (customerData && customerData.addressOne) || "",
    barangay: (customerData && customerData.barangay) || "",
    city: (customerData && customerData.city) || "",
    zipcode: (customerData && customerData.zipcode) || "",
    country: (customerData.country && customerData.country) || {},
    province: (customerData.state && customerData.state) || {},
    addressLineTwo: (customerData && customerData.addressTwo) || "",
    firstName: (customerData && customerData.firstName) || "",
    lastName: (customerData && customerData.lastName) || "",
    mobile: (customerData &&
      customerData.mobile && {
        countryCode: customerData.mobile.countryCode || "",
        mobileNumber: customerData.mobile.mobileNumber || ""
      }) || {
      countryCode: "",
      mobileNumber: ""
    },
    email: (customerData && customerData.email) || "",
    terms: false
  }),
  validationSchema: Yup.object().shape({
    password: Yup.string()
      .required("Please enter a password.")
      .min(8, "Password must be at least 8 characters."),
    addressLineOne: Yup.string().required("Please enter address."),
    firstName: Yup.string().required("Please enter first name."),
    lastName: Yup.string().required("Please enter last name."),
    barangay: Yup.string().when(
      "country",
      country =>
        country && country.value === "philippines"
          ? Yup.object().test(
              "test-barangay",
              "Please enter a barangay.",
              function(barangay) {
                if (
                  barangay &&
                  barangay.label &&
                  barangay.label !== "" &&
                  barangay.value &&
                  barangay.value !== ""
                ) {
                  return true
                }
                return false
              }
            )
          : Yup.object()
    ),
    city: Yup.string().when(
      "country",
      country =>
        country && country.value === "philippines"
          ? Yup.object().test("test-city", "Please enter a city.", function(
              city
            ) {
              if (
                city &&
                city.label &&
                city.label !== "" &&
                city.value &&
                city.value !== ""
              ) {
                return true
              }
              return false
            })
          : Yup.string().required("Please enter a city.")
    ),
    zipcode: Yup.string()
      .matches(/^($)|([0-9]{4,13}$)/, "Please enter a valid zip code.")
      .min(3, "Please enter a valid zip code.")
      .max(5, "Please enter a valid zip code.")
      .required("Please enter a zip code."),
    province: Yup.object().test(
      "test-state",
      "Please enter a province/state.",
      function(state) {
        if (
          state &&
          state.label &&
          state.label !== "" &&
          state.value &&
          state.value !== ""
        ) {
          return true
        }
        return false
      }
    ),
    country: Yup.object().test(
      "test-country",
      "Please enter a country.",
      function(country) {
        if (
          country &&
          country.label &&
          country.label !== "" &&
          country.value &&
          country.value !== ""
        ) {
          return true
        }
        return false
      }
    ),
    mobile: Yup.object()
      .shape({
        countryCode: Yup.string()
          .matches(
            /^($)|(\+?\d{1,3}$|\d{1,4})/,
            "Please enter a valid country code."
          )
          .max(4, "Please enter a valid country code.")
          .typeError("Country code and mobile number should be filled.")
          .required("Please enter a country code."),
        mobileNumber: Yup.string()
          .matches(/^($)|([0-9]{4,10})/, "Please enter a valid mobile number.")
          .max(13, "Please enter a valid mobile number.")
          .required("Please enter a mobile number.")
          .typeError("Country code and mobile number should be filled.")
      })
      .test("test-phone", "Mobile number is invalid.", function(mobile) {
        if (`${mobile.countryCode}${mobile.mobileNumber}` !== "") {
          try {
            parsePhoneNumber(`${mobile.countryCode}${mobile.mobileNumber}`)
            return true
          } catch (e) {
            return false
          }
        }
        return true
      }),
    email: Yup.string()
      .email("Please enter a valid email.")
      .required("Please enter an email."),
    terms: Yup.boolean().oneOf(
      [true],
      "Please indicate that you accepted the Terms & Conditions and Privacy Policy."
    )
  }),
  handleSubmit: async (
    values,
    { props, setSubmitting, setErrors, setFieldError }
  ) => {
    let addressLineOne = values.addressLineOne
    let city =
      values.country.value === "philippines" ? values.city.value : values.city
    let barangay =
      values.country.value === "philippines" ? values.barangay.value : null
    let zipcode = values.zipcode
    let country = values.country.value
    let province = values.province.value
    let addressLineTwo = values.addressLineTwo
    let firstName = values.firstName
    let lastName = values.lastName
    let mobile = {
      countryCode: values.mobile.countryCode.trim(),
      mobileNumber: values.mobile.mobileNumber.trim()
    }
    let email = values.email
    let password = values.password
    let photo_url = values.photo_url || null
    let notes = values.notes || null
    let gender = values.gender || null
    let birthday = values.birthday || null
    let groups = values.groups || []
    const uuid = props.uuid
    const body = {
      auth_token: null,
      firstname: firstName,
      lastname: lastName,
      email: email,
      mobile: mobile.mobileNumber,
      mobile_country_code: mobile.countryCode,
      photo_url: photo_url,
      notes: notes,
      gender: gender,
      birthday: birthday,
      address_line_1: addressLineOne,
      address_line_2: addressLineTwo,
      city: city,
      zipcode: zipcode,
      country: country,
      province: province,
      groups: groups,
      pass: password,
      order_uuid: props.orderUUID || null,
      barangay: barangay || null
    }
    console.log("Create Account Props: ", props)
    const signUpUrl = props.isNewOrder
      ? `/customers/${props.accountUuid}/sign_up`
      : `/customers/${uuid}/sign_up`
    try {
      const res = props.isNewOrder
        ? await API_PUBLIC.post(signUpUrl, JSON.stringify(body))
        : await API.post(signUpUrl, JSON.stringify(body))
      if (res) {
        setSubmitting(false)
        const customerData = props.isNewOrder ? res.data.customer : null
        props.submitCallback && props.submitCallback(customerData)
      }
    } catch (err) {
      console.log(err.response)
      const { errors } = err.response.data
      if (errors && errors.length > 0) {
        errors.forEach(error => {
          if (error.code === "customers/email-already-exists") {
            setFieldError("email", "Customer email is already in use.")
          }
          if (error.code === "customers/mobile-already-exists") {
            setFieldError("mobile", "Mobile number is already in use.")
          }
          if (error.code === "customers/invalid-mobile-number") {
            setFieldError("mobile", "Mobile number is invalid.")
          }
        })
      } else if (
        (err.response.data.code &&
          err.response.data.code === "customers/invalid-mobile-number") ||
        err.response.data.code === "customers/mobile-already-exists"
      ) {
        setErrors({
          mobile: "Mobile number is invalid."
        })
      }
      if (
        err.response.data.message === "ACCOUNT_EXISTS!" ||
        err.response.data.code === "customers/mobile-already-exists"
      ) {
        setErrors({
          mobile: "The mobile number you entered is already registered with us."
        })
      }
      if (
        err.response.data.errors &&
        err.response.data.errors[0].includes("country")
      ) {
        setErrors({
          country: "Please select a country."
        })
      }
      setSubmitting(false)
    }
  }
})(BaseAccountForm)

export default CreateAccountForm
